import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import { useEffect, useState } from "react"

import { useAuthorizedAxiosClient } from "../../../common/axios"
import LengthLimitedTextField from "../../../common/components/LengthLimitedTextField"
import DialogHeader from "../components/DialogHeader"
import { getStageNameError } from "./utils"

export default function RenameStageDialog({
  open,
  onClose,
  stage,
  existingStages,
}) {
  const [name, setName] = useState("")
  const [isRenaming, setIsRenaming] = useState(false)
  const axios = useAuthorizedAxiosClient()
  const nameError = getStageNameError(existingStages, name)

  function handleSoftClose() {
    onClose()
  }

  function handleRenameButtonClicked() {
    setIsRenaming(true)
    axios
      .put(`/crm/api/crm-stages/${stage.id}/`, { name })
      .then(({ data }) => {
        setName("")
        onClose(data)
      })
      .finally(() => setIsRenaming(false))
  }

  useEffect(() => {
    setName(stage.name)
  }, [stage])

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogHeader title="Rename Stage" onClose={handleSoftClose} />
      <DialogContent>
        <LengthLimitedTextField
          label="Name"
          value={name}
          setValue={setName}
          required
          error={!!nameError}
          helperText={nameError}
          maxLength={64}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleSoftClose}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="primary"
          disabled={name.length === 0 || !!nameError}
          loading={isRenaming}
          onClick={handleRenameButtonClicked}
        >
          Rename
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
